/** The app is never zoomed by the browser on a touch screen (owner,
 *  2026-10-18: "I should never be able to unnaturally zoom in on any part of
 *  the app that doesn't have that feature, because then the app looks broken").
 *
 *  Three layers, because each platform listens to a different one:
 *  - the viewport tag in `index.html` (`maximum-scale=1, user-scalable=no`):
 *    Android Chrome, the store builds' web views, and iOS's zoom-on-focus of a
 *    small text field;
 *  - `touch-action: pan-x pan-y` on `<html>` (`styles/app.css`): double-tap
 *    zoom, and pinch wherever `touch-action` is honoured;
 *  - this file: Safari on iPhone and iPad ignores both for a pinch since
 *    iOS 10, but a pinch arrives as WebKit's `gesture*` events first, and
 *    cancelling `gesturestart` keeps the page at its own scale.
 *
 *  Nothing in the app reads a pinch of its own (a second finger on Scripture
 *  is ignored by `tabs/read/verseGesture.ts`), so nothing is taken away. Text
 *  Size and App Font size are how to read larger. Desktop browser zoom (Ctrl
 *  and +) is the browser's own and stays. */
export function installNoZoom(): void {
  if (typeof document === 'undefined') return;
  const stop = (e: Event): void => { e.preventDefault(); };
  for (const type of ['gesturestart', 'gesturechange', 'gestureend']) {
    document.addEventListener(type, stop, { passive: false });
  }
}
